import { useForm }  from "react-hook-form";
import '../../styles/LoginForm.css';


export default function ChangePasswordForm({onSubmit, responseMessage, username}){

    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    return (
        <div className="flex flex-col gap-[20px] xl:translate-y-[30px] xl:px-[85px] px-[30px] translate-y-[25px] items-center">

            <h1 className="xl:text-center xl:text-[1.3rem] xl:leading-10 xl:text-black text-white">Trocar senha</h1>

            <p className="xl:text-black text-white text-center text-sm">
                Olá, <b>{username}</b>! Por segurança, você precisa definir uma nova senha
                (mínimo de 12 caracteres) antes de acessar o sistema.
            </p>

            <div className="xl:omrs-input-group w-[100%] justify-center flex">
                <label className="omrs-input-filled xl:w-[100%] w-[100%] ">
                    <input
                        className='!w-[100%] !text-[1.4rem] py-[5px] px-[6px]'
                        type="password"
                        placeholder="Nova senha"
                        {...register("newPassword", { required: true, minLength: 12 })}
                    />
                    <span className="xl:omrs-input-label hidden">Nova senha</span>
                </label>
            </div>

            <div className="xl:omrs-input-group w-[100%] justify-center flex">
                <label className="omrs-input-filled xl:w-[100%] w-[100%] ">
                    <input
                        className='!w-[100%] !text-[1.4rem] py-[5px] px-[6px]'
                        type="password"
                        placeholder="Confirmar nova senha"
                        {...register("confirmPassword", {
                            required: true,
                            validate: (value) => value === watch("newPassword")
                        })}
                    />
                    <span className="xl:omrs-input-label hidden">Confirmar nova senha</span>
                </label>
            </div>

            <button
                id="change-password-btn"
                type="submit"
                onClick={handleSubmit(onSubmit)}
                className='w-[100%] [transition:0.3s_ease] text-[1.2rem] text-[white] outline-[none] border-[none] p-[8px] rounded-[4px] cursor-pointer mx-[0] my-[5px] font-saira btn-azul-prof'>
                Salvar e entrar
            </button>

            <p
                className={`h-[50px] w-full text-red-600 text-center text-sm font-medium transition-all duration-500 ease-in-out
                ${(responseMessage || errors.newPassword || errors.confirmPassword) ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}
            >
                {errors.newPassword && 'A nova senha deve ter no mínimo 12 caracteres.'}
                {!errors.newPassword && errors.confirmPassword && 'As senhas não conferem.'}
                {!errors.newPassword && !errors.confirmPassword && responseMessage}
            </p>

        </div>
    )
}
